import React from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import DoughnutChartComponent from '../DoughnutChartComponent';
import Chart from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(ChartDataLabels);

const RedditTrackerChart = ({ data }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    if (!data || data.length === 0) {
        return null;
    }

    // Hide chart on mobile - ADD THESE 3 LINES
    if (isMobile) {
        return null;
    }

    // More vibrant and distinct color palette (matches competitor style)
    const colors = [
        '#4A9B9F', // Teal (NVDA style)
        '#6B8DC8', // Blue (AVGO style)  
        '#C56FA0', // Purple-pink (ORCL style)
        '#E67B9F', // Pink (MSTR style)
        '#F09478', // Coral (TSLA/NFLX style)
        '#F5B86A', // Orange (CVNA style)
        '#F9D962', // Yellow (META style)
        '#D9C75C', // Yellow-green (KRMN style)
        '#8B7FA8', // Purple (HOOD style)
        '#A385B5', // Light purple (RKLB style)
        '#D17B9F', // Rose (ASTS style)
        '#5FA8B8', // Cyan
        '#E8A87C', // Peach
        '#95C792', // Green
        '#B894C7', // Lavender
        '#F7B5A7', // Salmon
        '#7EC8E3', // Sky blue
        '#FFB347'  // Light orange
    ];

    // Take top 12 stocks for chart
    const chartData = data.slice(0, 12);

    const labels = chartData.map(item => item.symbol);
    const values = chartData.map(item => item.weightPercentage);
    const backgroundColor = labels.map((_, index) => colors[index % colors.length]);

    const chartConfig = {
        labels: labels,
        datasets: [
            {
                data: values,
                backgroundColor: backgroundColor,
                hoverBackgroundColor: backgroundColor,
                borderWidth: 2,
                borderColor: theme.palette.mode === 'dark' ? '#0A1929' : '#ffffff',
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: {
                top: 40,
                bottom: 40,
                left: 40,
                right: 40
            }
        },
        plugins: {
            legend: {
                display: false // Hide default legend
            },
            tooltip: {
                enabled: true,
                callbacks: {
                    label: function (context) {
                        const label = context.label || '';
                        const value = context.parsed || 0;
                        return `${label}: ${value.toFixed(2)}%`;
                    }
                }
            },
            datalabels: {
                color: theme.palette.text.primary,
                font: {
                    size: 13,
                    weight: '600'
                },
                formatter: (value, context) => {
                    const label = context.chart.data.labels[context.dataIndex];
                    return `${label}: ${value.toFixed(2)}%`;
                },
                anchor: 'end',
                align: 'end',
                offset: 8,
                clip: false,
                textAlign: 'center'
            }
        },
        animation: {
            animateScale: true,
            animateRotate: true
        }
    };

    return (
        <Box sx={{ height: { xs: 400, sm: 450, md: 500 }, position: 'relative', p: 2 }}>
            <DoughnutChartComponent chartData={chartConfig} options={options} />
        </Box>
    );
};

export default RedditTrackerChart;